import React from "react";

function Footer() {
  return (
    <footer style={{ backgroundColor: "rgb(240, 240, 240)" }}>
      <div className="container border-top mt-5">
        <div className="row mt-5 gy-4">
          <div className="col-12 col-sm-6 col-lg-3">
            <img
              src="media/images/logo.svg"
              alt="logo"
              className="brand-logo footer-logo"
            />
            <p>&copy; 2010 - 2025, Zerodha Broking Ltd. All rights reserved.</p>
          </div>
          <div className="col-12 col-sm-6 col-lg-3">
            <p>Company</p>
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              About
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Philosophy
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Press & media
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Careers
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Zerodha Cares (CSR)
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Zerodha.tech
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Open source
            </a>{" "}
            <br />
          </div>
          <div className="col-12 col-sm-6 col-lg-3">
            <p>Support</p>
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Contact us
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Support portal
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              How to file a complaint?
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Status of your complaints
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Bulletin
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Circular
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Z-Connect blog
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Downloads
            </a>
            <br />
          </div>
          <div className="col-12 col-sm-6 col-lg-3">
            <p>Account</p>
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Open demat account
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Minor demat account
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              NRI demat account
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Commodity
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Dematerialisation
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Fund transfer
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              MTF
            </a>
            <br />
            <a
              href=""
              className="text-decoration-none text-muted"
              style={{ color: "#000" }}
            >
              Referral program
            </a>
            <br />
          </div>
        </div>
        <div className="mt-5 text-muted" style={{ fontSize: "13px" }}>
          <p>
            Zerodha Broking Ltd. is a SEBI-registered member of NSE, BSE, MCX,
            and a depository participant. For complaints, email
            complaints@zerodha.com (broking) or dp@zerodha.com (DP). Grievances
            can also be filed via the SEBI SCORES portal. Investments in the
            securities market are subject to market risks; always read the
            related documents. Key investor updates: Stock brokers can only
            accept securities as margins via pledge. Update your email and phone
            number with your broker/DP to receive OTPs for pledges and
            transaction information directly from the Exchange. Check your
            securities in the consolidated account statement (NSDL/CDSL) every
            month. KYC is a one-tine exercise. For IPOs, authorize your bank for
            payment; no cheque is needed. Zerodha does not give stock tips or
            authorize anyone to trade on behalf of others. Please report anyone
            claiming to do so.
          </p>

          <p>
            Attention investors: 1) Stock brokers can accept securities as
            margins from clients only by way of pledge in the depository system
            w.e.f September 01, 2020. 2) Update your e-mail and phone number
            with your stock broker / depository participant and receive OTP
            directly from depository on your e-mail and/or mobile number to
            create pledge. 3) Check your securities / MF / bonds in the
            consolidated account statement issued by NSDL/CDSL every month.
          </p>

          <p>
            "Prevent unauthorised transactions in your account. Update your
            mobile numbers/email IDs with your stock brokers. Receive
            information of your transactions directly from Exchange on your
            mobile/email at the end of the day. Issued in the interest of
            investors. KYC is one time exercise while dealing in securities
            markets - once KYC is done through a SEBI registered intermediary
            (broker, DP, Mutual Fund etc.), you need not undergo the same
            process again when you approach another intermediary." Dear
            Investor, if you are subscribing to an IPO, there is no need to
            issue a cheque. Please write the Bank account number and sign the
            IPO application form to authorize your bank to make payment in case
            of allotment. In case of non allotment the funds will remain in your
            bank account. As a business we don't give stock tips, and have not
            authorized anyone to trade on behalf of others. If you find anyone
            claiming to be part of Zerodha and offering such services
          </p>
        </div>

        <div className="mb-2 text-center">
          <ul className="list-inline">
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                NSE
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                BSE
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                MCX
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                Terms & conditions
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                Policies & procedures
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                Privacy policy
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                Disclosure
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                For investor's attention
              </a>
            </li>
            <li className="list-inline-item mx-2">
              <a href="" className="text-decoration-none text-muted small">
                Investor and Charters
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
